import React from 'react'

export const Dropdown = () => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" className='dropdown-icon'>
      <path fillRule="evenodd" clipRule="evenodd" d="M5.70711 6.24422C5.31658 6.63474 4.68342 6.63474 4.29289 6.24422L0.292892 2.24422C-0.0976325 1.85369 -0.0976325 1.22053 0.292892 0.830002C0.683416 0.439478 1.31658 0.439478 1.70711 0.830002L5 4.1229L8.29289 0.830002C8.68342 0.439478 9.31658 0.439478 9.70711 0.830002C10.0976 1.22053 10.0976 1.85369 9.70711 2.24422L5.70711 6.24422Z" fill="#4C4C4C" />
    </svg>
  )
}
